<div class="p-10">
  @if (isAuthFail) {
    <div class="alert alert-danger">{{ insufficientAuthMessage }}</div>
  }
  <form nz-form nz-row [formGroup]="adjustVoidTimesheetForm" class="ppl-p0 mt-2">

    <div class="table-scroll-wrapper">
    <table class="invoice-adjust-table" [class.wide-layout]="actionType === 'adjustTimesheet'">

      <thead>
        <tr>
          @if(actionType === 'adjustTimesheet') {
            <th style="background-color: #a8e4e14d; width: 6%;"></th>
          }
          <!-- Service Date — adjust only -->
          @if (actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet') {
          <th style="background-color: #a8e4e14d; width: 13%;">
            Service<br>Date <span class="required-marker">*</span>
          </th>
          }

          <!-- Service Code — adjust only -->
          @if (actionType === 'adjustTimesheet'  || actionType === 'adjustAllTimesheet') {
          <th style="background-color: #a8e4e14d; width: 11%;">
            Service<br>Code <span class="required-marker">*</span>
          </th>
          }

          <!-- Service Description — adjust only -->
          @if (actionType === 'adjustTimesheet') {
          <th style="background-color: #a8e4e14d; width: 15%;">
            Service<br>Description <span class="required-marker">*</span>
          </th>
          <th style="background-color: #a8e4e14d; width: 12%;">
            PPL Authorization<br>Number
          </th>
          <th style="background-color: #a8e4e14d; width: 12%;">
            Regional<br>Center
          </th>
          }

          <!-- Units -->
          @if (actionType === 'adjustTimesheet') {
          <th style="background-color: #a8e4e14d; width: 8%;">
            Units <span class="required-marker">*</span>
          </th>
          }

          <!-- Amount -->
          @if (actionType === 'adjustTimesheet') {
          <th style="background-color: #a8e4e14d; width: 9%;">
            Amount <span class="required-marker">*</span>
          </th>
          }

          <!-- Reason -->
          <th style="background-color: #a8e4e14d; width: 17%;">
            {{ actionType === 'voidTimesheet' || actionType === 'voidAllTimesheets' ? 'Void' : 'Adjust' }}<br>Reason
            <span class="required-marker">*</span>
          </th>
          <th style="background-color: #a8e4e14d; width: 17%;">
            Reason<br>Details
            @if(adjustVoidTimesheetForm.get('reason')?.value?.lkpValueName === 'Other') {
              <span class="required-marker">*</span>
            }
          </th>
          <!-- CRM Number — required for both Adjust and Void -->
          <th style="background-color: #a8e4e14d; width: 12%;">
            CRM<br>Number <span class="required-marker">*</span>
          </th>
        </tr>
      </thead>

      <tbody>

        <!-- INPUT ROW -->
        <tr>
          @if (actionType === 'adjustTimesheet') {
            <td><b>New values</b></td>
          }
          <!-- Service Date -->
          @if (actionType === 'adjustTimesheet'  || actionType === 'adjustAllTimesheet') {
          <td>
            <nz-date-picker formControlName="serviceDate" id="serviceDate" nzPlaceHolder="Service Date"
              [nzFormat]="'MM/dd/yyyy'" nzAllowClear="false"
              [nzStatus]="adjustVoidTimesheetForm.get('serviceDate')?.invalid && adjustVoidTimesheetForm.get('serviceDate')?.touched ? 'error' : ''">
            </nz-date-picker>
          </td>
          }

          <!-- Service Code -->
          @if (actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet') {
          <td>
            <nz-select formControlName="serviceCode" class="filters" id="serviceCode" nzPlaceHolder="Service Code"
              nzShowSearch nzAllowClear
              [compareWith]="compareServiceCode"
              (ngModelChange)="onServiceCodeChange($event)"
              [nzStatus]="adjustVoidTimesheetForm.get('serviceCode')?.invalid && adjustVoidTimesheetForm.get('serviceCode')?.touched ? 'error' : ''">
              @for (opt of serviceCodes; track $index) {
              <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt"></nz-option>
              }
            </nz-select>
          </td>
          }
          @if (actionType === 'adjustTimesheet') {
            <td>
              <nz-select formControlName="serviceDescription" class="filters" id="serviceDescription"
                nzPlaceHolder="Service Description" nzShowSearch nzAllowClear
                (ngModelChange)="onServiceDescriptionChange($event)"
                [nzStatus]="adjustVoidTimesheetForm.get('serviceDescription')?.invalid && adjustVoidTimesheetForm.get('serviceDescription')?.touched ? 'error' : ''">
                @for (opt of serviceDescriptions; track $index) {
                <nz-option [nzLabel]="opt.desc" [nzValue]="opt.ids"></nz-option>
                }
              </nz-select>
            </td>
            <td>
              <span class="previous-value" id="pplAuthNum">{{ selectedPplAuthNum }}</span>
            </td>
            <td>
              <span class="previous-value" id="regionalCenter">{{ selectedRegionalCenter }}</span>
            </td>
            <td>
              <input
                nz-input
                type="number"
                formControlName="billedUnits"
                placeholder="Units" />
            </td>
            <td>
              <input
                nz-input
                type="number"
                formControlName="unitPrice"
                placeholder="Amount" />
            </td>
          }
          <!-- Reason -->
          <td>
            <nz-select formControlName="reason" class="filters" id="reason" nzPlaceHolder="Select Reason" nzShowSearch
              nzAllowClear
              [nzStatus]="adjustVoidTimesheetForm.get('reason')?.invalid && adjustVoidTimesheetForm.get('reason')?.touched ? 'error' : ''">
              <nz-option *ngFor="let opt of reasonList" [nzLabel]="opt.lkpValueName" [nzValue]="opt">
              </nz-option>
            </nz-select>
          </td>
          <td>
              <input nz-input formControlName="reasonDetails" placeholder="Enter reason details"
                  maxlength="160"
                  [class.ant-input-status-error]="adjustVoidTimesheetForm.get('reasonDetails')?.invalid && adjustVoidTimesheetForm.get('reasonDetails')?.touched" />
          </td>
          <!-- CRM Number input -->
          <td>
            <input nz-input formControlName="crmNumber" placeholder="Enter CRM Number"
                maxlength="50"
                [class.ant-input-status-error]="adjustVoidTimesheetForm.get('crmNumber')?.invalid && adjustVoidTimesheetForm.get('crmNumber')?.touched" />
          </td>
        </tr>
        <tr>
          @if (actionType === 'adjustTimesheet') {
            <td></td>
          }
          @if (actionType === 'adjustTimesheet') {
          <td>
            <div class="error-message">
              @if (adjustVoidTimesheetForm.get('serviceDate')?.invalid &&
              adjustVoidTimesheetForm.get('serviceDate')?.touched) {
              Please select the service date
              }
            </div>
          </td>
          <td>
            <div class="error-message">
              @if (adjustVoidTimesheetForm.get('serviceCode')?.invalid &&
              adjustVoidTimesheetForm.get('serviceCode')?.touched) {
              Please select the service code
              }
            </div>
          </td>
          <td>
            <div class="error-message">
              @if (adjustVoidTimesheetForm.get('serviceDescription')?.invalid &&
              adjustVoidTimesheetForm.get('serviceDescription')?.touched) {
              Please select the service description
              }
            </div>
          </td>
          <td></td>
          <td></td>
          <td>
            <div class="error-message">
              @if (adjustVoidTimesheetForm.get('billedUnits')?.invalid &&
              adjustVoidTimesheetForm.get('billedUnits')?.touched) {
              Please enter units
              }
            </div>
          </td>
          <td>
            <div class="error-message">
              @if (adjustVoidTimesheetForm.get('unitPrice')?.invalid &&
              adjustVoidTimesheetForm.get('unitPrice')?.touched) {
              Please enter amount
              }
            </div>
          </td>

          }
          @if (actionType === 'adjustAllTimesheet') {
            <td>
              <div class="error-message">
                @if (adjustVoidTimesheetForm.get('serviceDate')?.invalid &&
                adjustVoidTimesheetForm.get('serviceDate')?.touched) {
                Please select the service date
                }
              </div>
            </td>
            <td>
              <div class="error-message">
                @if (adjustVoidTimesheetForm.get('serviceCode')?.invalid &&
                adjustVoidTimesheetForm.get('serviceCode')?.touched) {
                Please select the service code
                }
              </div>
            </td>
          }
          <td>
            <div class="error-message">
              @if (adjustVoidTimesheetForm.get('reason')?.invalid &&
              adjustVoidTimesheetForm.get('reason')?.touched) {
              Please select reason
              }
            </div>
          </td>
          <td>
            <div class="error-message">
              @if(adjustVoidTimesheetForm.get('reasonDetails')?.invalid && adjustVoidTimesheetForm.get('reasonDetails')?.touched) {
                Please enter the reason details
              }
            </div>
          </td>
          <td>
            <div class="error-message">
              @if(adjustVoidTimesheetForm.get('crmNumber')?.invalid && adjustVoidTimesheetForm.get('crmNumber')?.touched) {
                Please enter the CRM Number
              }
            </div>
          </td>
        </tr>

        <!-- Row 3: Previous values — adjust only -->
        @if (actionType === 'adjustTimesheet') {
        <tr>
          <td><b>Previous Values</b></td>
          <td>
            <span class="previous-value">{{ timesheetData?.serviceDate }}</span>
          </td>
          <td>
            <span class="previous-value">{{ timesheetData?.serviceCode?.lkpValueName }}</span>
          </td>
          <td>
            <span class="previous-value">{{ timesheetData?.authDesc }}</span>
          </td>
          <td></td>
          <td></td>
          <td>
            <span class="previous-value">{{ timesheetData?.billedUnits }}</span>
          </td>
          <td>
            <span class="previous-value">{{ timesheetData?.unitPrice }}</span>
          </td>
          <td></td>
          <td></td>
          <td>
            <span class="previous-value">{{ timesheetData?.crmNumber }}</span>
          </td>
        </tr>
        }

      </tbody>
    </table>
    </div>

    <!-- SAVE BUTTON -->
    <div class="custom-row w-100 save-row">
      <ppl-button
        (click)="onSave()"
        [styleString]="'margin-right: 8px;'"
        label="{{ buttonLabel }}"
        icon="fa fa-check-circle"
        [customClass]="'primary-button'"
        [iconPosition]="'right'">
      </ppl-button>
    </div>

  </form>
</div>
